module.exports = __webpack_public_path__ + "7b3aa4a9d9a0e2c405221f07ee15e224.pdf";